import { Capacitor } from "@capacitor/core";
import { openExternalUrl } from "./open-external-url";

const IOS_SUBSCRIPTION_MANAGEMENT_URL = "https://apps.apple.com/account/subscriptions";
const ANDROID_SUBSCRIPTION_MANAGEMENT_URL = "https://play.google.com/store/account/subscriptions";

const getDefaultSubscriptionManagementUrl = () => {
  const platform = Capacitor.getPlatform();

  if (platform === "ios") {
    // Staging too: the page won't list Sandbox subscriptions (the in-app hint
    // points QA to Settings > Developer > Sandbox Apple Account), but opening it
    // keeps the button working and exercises the same path as production.
    return IOS_SUBSCRIPTION_MANAGEMENT_URL;
  }

  if (platform === "android") {
    return ANDROID_SUBSCRIPTION_MANAGEMENT_URL;
  }

  return null;
};

export const openSubscriptionManagement = (managementURL?: string | null) => {
  const targetUrl = managementURL ?? getDefaultSubscriptionManagementUrl();
  if (!targetUrl) return false;

  openExternalUrl(targetUrl);
  return true;
};
